// let host = process.env.VUE_APP_MYHOST
let authhost = process.env.VUE_APP_AUTHHOST
authhost = 'https://merch.mifors.com/'
let host = 'https://merch.mifors.com/'
export const config = {
  apiUrl: host + 'api/',
  authUrl: authhost + 'merchauthserver/oauth/token',
  client: {
    id: 'fooClientIdPassword',
    secret: 'secret'
  },
  image: (img, year, month, day) => `https://merchcoord.mifors.com/res/${year}/${month}/${day}/reportphoto_${img.uuid}.${img.extension}`,
  tmpimage: (uuid) => `${config.apiUrl}tempfiles/${uuid}`
}